<template>
  <div class="container page-py mobile-container">
    <h2>
      {{ $t('aboutDreamFlat') }}
    </h2>
    <div style="scroll-behavior: smooth">
      <div class="main-info">
        <div id="general" ref="general" class="paragraph-block">
          <h3 id="howWhyUse">
            {{ $t('howWhyUse') }}
          </h3>
          <p>
            {{ $t('userFriendlyWind10ConstructorDesign') }}
          </p>
          <p>
            {{ $t('uniqueInteriorExtensiveLibrary') }}
          </p>
          <p>
            {{ $t('uploadOwnModels') }}
          </p>
          <p>
            {{ $t('freemium') }}
          </p>
          <p>
            {{ $t('comprehensiveFunctionality') }}
          </p>
          <div class="image-carousel">
            <ImagesCustomSlider
              :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/sc-about-carousel1-1.webp`,
                `${staticUrl}/images/sc-about-carousel1-2.webp`,
                `${staticUrl}/images/sc-about-carousel1-3.webp`,
                `${staticUrl}/images/sc-about-carousel1-4.webp`,
                `${staticUrl}/images/sc-about-carousel1-5.webp`,
              ]"
            />
          </div>
        </div>
        <div
          id="opportunities"
          ref="opportunities"
          class="paragraph-block"
        >
          <h3 id="dreamFlatFunctionality">
            {{ $t('dreamFlatFunctionality') }}
          </h3>
          <div id="tools" ref="tools">
            <div class="paragraph-steps">
              <h4>
                {{ $t('preInstalledModels') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('libraryExpanding') }}
              </p>
              <div class="image-carousel">
                <ImagesCustomSlider
                  :height="null"
                  width="100%"
                  :images="[
                    `${staticUrl}/images/sc-about-carousel2-1.webp`,
                    `${staticUrl}/images/sc-about-carousel2-2.webp`,
                    `${staticUrl}/images/sc-about-carousel2-3.webp`,
                  ]"
                />
              </div>
            </div>
            <div class="paragraph-steps">
              <h4>
                {{ $t('finishing') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('finishing100Options') }}
              </p>
              <img
                :src="`${staticUrl}/images/sc-about-img1.webp`"
                alt=""
                class="article-image"
              />
            </div>
            <div class="paragraph-steps">
              <h4>
                {{ $t('uploadUrModels') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('enterpriseSubscribers') }}
              </p>
            </div>
            <div class="paragraph-steps">
              <h4>
                {{ $t('customizableModels') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('customizeModels') }}
              </p>
            </div>
            <div class="paragraph-steps">
              <h4>
                {{ $t('primitivesFive') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('offersPrimitives') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('geometricShapes') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('primitivesDesigner') }}
              </p>
            </div>
          </div>
          <div id="results" ref="results">
            <h3 id="finResult">
              {{ $t('finResult') }}
            </h3>
            <div class="paragraph-steps">
              <h4>
                {{ $t('fiveWaysShowing') }}
              </h4>
              <p class="paragraph-steps-text">
                {{ $t('options5Presenting') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('useRendersForAdding') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('showInterior') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('viewerApartment') }}
              </p>
              <div class="image-carousel">
                <ImagesCustomSlider
                  :height="null"
                  width="100%"
                  :images="[
                    `${staticUrl}/images/sc-about-carousel3-1.webp`,
                    `${staticUrl}/images/sc-about-carousel3-2.webp`,
                    `${staticUrl}/images/sc-about-carousel3-3.webp`,
                    `${staticUrl}/images/sc-about-carousel3-4.webp`,
                    `${staticUrl}/images/sc-about-carousel3-5.webp`,
                    `${staticUrl}/images/sc-about-carousel3-6.webp`,
                  ]"
                />
              </div>
            </div>
          </div>
          <div id="graphic" ref="graphic" class="sub-paragraph-block">
            <h3 id="uEngine5Graphics">
              {{ $t('uEngine5Graphics') }}
            </h3>
            <div class="paragraph-steps">
              <p class="paragraph-steps-text">
                {{ $t('dreamFlatUsesLatestUnrealEngine') }}
              </p>
              <p class="paragraph-steps-text">
                {{ $t('rayTracingRenderingTake') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {useI18n} from 'vue-i18n';
import {useHead} from '#imports';
import {useRuntimeConfig} from '#imports';

const {t} = useI18n();
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

useHead({
  title: `${t('aboutDreamFlat')}`,
  meta: [
    {
      name: 'description',
      content: `${t('aboutDfMetaDesc')}`,
    },
  ],
});
useSeoMeta({
  ogTitle: `${t('aboutDreamFlat')}`,
  description: `${t('aboutDfMetaDesc')}`,
  ogDescription: `${t('aboutDfMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
});
</script>
<style lang="scss" scoped>
@import 'css/help-center/help-center-general-ctyle';
@media (max-width: $lg) {
  .main-info {
    width: 100%;
  }
  .table-contents {
    width: 100%;
  }
  .mobile-container {
    padding: 0 16px;
    margin-top: 32px;
  }
}
</style>
